import { type FragmentType, useFragment } from "@repo/graphql-types";
import { graphql } from "@repo/graphql-types/gql";
import { formatCurrency } from "@repo/lib";
import { getAssistVariablePrices } from "@/lib/assist-utils";

export const SubscribedAssistProPriceFragment = graphql(/* GraphQL */ `
  fragment SubscribedAssistProPriceFragment on pacoteServicoPreco {
    valorUnitarioFixo
    pacotesServicosPrecosVariaveis {
      valorUnitario
      codPacoteServicosPrecoVariavel
    }
  }
`);

interface SubscribedAssistProPriceProps {
  data: FragmentType<typeof SubscribedAssistProPriceFragment>;
}

export const SubscribedAssistProPrice = ({
  data,
}: SubscribedAssistProPriceProps): JSX.Element => {
  const priceData = useFragment(SubscribedAssistProPriceFragment, data);

  const pricePackageService = priceData.pacotesServicosPrecosVariaveis;

  const { digitalContactVariablePrice, humanContactVariablePrice } =
    getAssistVariablePrices(pricePackageService);

  return (
    <>
      <div className="text-neutral-600 font-medium text-md mt-4">Livance Assist Pro</div>

      <div className="text-neutral-600 font-semibold text-2xl">
        {formatCurrency(priceData.valorUnitarioFixo)}
        <span className="text-xs"> /mês</span>
      </div>

      {digitalContactVariablePrice ? (
        <div className="text-neutral-500 text-xs mt-2 font-semibold">
          + {formatCurrency(digitalContactVariablePrice)}
          <span className="text-xs"> /atendimento digital</span>
        </div>
      ) : null}

      {humanContactVariablePrice ? (
        <div className="text-neutral-500 text-xs mt-2 font-semibold">
          + {formatCurrency(humanContactVariablePrice)}
          <span className="text-xs"> /atendimento humano</span>
        </div>
      ) : null}
    </>
  );
};
